
<template>
  <Layout>
    <b-modal
        id="modalUpload"
        scrollable
        title="Subir archivo"
        title-class="font-18"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadComplete" />
    </b-modal>
    <b-modal
        id="modalGastos"
        scrollable
        title="Gastos"
        title-class="font-24"
        size="xl"
        hide-footer

    >
      <b-overlay :show="isLoadingModal" rounded="sm">
        <form class="needs-validation" @submit.prevent="submitGastos">
        <b-tabs card  v-model="tab_activo">
          <b-tab title="Datos" active>
              <h1>  </h1>
              <div class="row">
                  <div class="form-group col-md-12">
                    <label>Expediente</label>
                    <v-select
                        :options="expedientes"
                        label="obra_expediente"
                        :reduce="desc=>desc.expediente_id"
                        v-model="gasto.expediente_id"
                        :class="{ 'is-invalid': submittedGastos && $v.gasto.expediente_id.$error }"
                        @input="cargarMetasClasificadores()"
                        :disabled="deshabilitar_formulario"
                    />
                    <div v-if="submittedGastos && $v.gasto.expediente_id.$error" class="invalid-feedback">
                      <span v-if="!$v.gasto.expediente_id.required">Este valor es requerido.</span>
                    </div>
                  </div>
              </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Fecha</label>
                <VueCtkDateTimePicker
                    v-model="gasto.fecha"
                    :locale="'es'"
                    :input-size="'sm'"
                    :format="'YYYY-MM-DD'"
                    :formatted="'YYYY-MM-DD'"
                    :range="false"
                    :auto-close="true"
                    :only-date="true"
                    :no-header="true"
                    :class="{ 'is-invalid': submittedGastos && $v.gasto.fecha.$error }"
                    :disabled="deshabilitar_formulario"
                />
                <!--style="position: fixed;width: 180px-->
                <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
                <div v-if="submittedGastos && $v.gasto.fecha.$error" class="invalid-feedback">
                  <span v-if="!$v.gasto.fecha.required">Este valor es requerido.</span>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label>Devengado</label>
                <select
                    class="form-control"
                    v-model="gasto.devengado"
                    @change="cambiarDevengado"
                >
                  <option value="1">Si</option>
                  <option value="0">No</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label>Fecha devengado</label>
                <VueCtkDateTimePicker
                    v-model="gasto.fecha_devengado"
                    :locale="'es'"
                    :input-size="'sm'"
                    :format="'YYYY-MM-DD'"
                    :formatted="'YYYY-MM-DD'"
                    :range="false"
                    :auto-close="true"
                    :only-date="true"
                    :no-header="true"
                    :disabled="deshabilitar_formulario"
                />
                <!--style="position: fixed;width: 180px-->
                <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
              </div>
              <div class="form-group col-md-3">
                <label>Meta</label>
                <v-select
                    :options="metas"
                    label="meta_anio"
                    :reduce="desc=>desc.meta_id"
                    v-model="gasto.meta_id"
                    :class="{ 'is-invalid': submittedGastos && $v.gasto.meta_id.$error }"
                    :disabled="deshabilitar_formulario"
                />
                <div v-if="submittedGastos && $v.gasto.meta_id.$error" class="invalid-feedback">
                  <span v-if="!$v.gasto.meta_id.required">Este valor es requerido.</span>
                </div>


              </div>


            </div>
              <div class="row">

                <div class="form-group col-md-3">
                  <label>Tipo</label>
                  <select
                      class="form-control"
                      v-model="gasto.tipo_gasto"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.tipo_gasto.$error }"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="10">Planilla</option>
                    <option value="20">Orden de compra</option>
                    <option value="30">Habilitación caja chica</option>
                    <option value="40">Habilitación de encargo interno</option>
                    <option value="50">Servicios</option>
                    <option value="60">Cuota patronal</option>
                  </select>
                  <div v-if="submittedGastos && $v.gasto.tipo_gasto.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.tipo_gasto.required">Este valor es requerido.</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label>Nº de documento</label>
                  <input
                      class="form-control" v-model="gasto.numero_documento"
                      :disabled="deshabilitar_formulario"
                  />
                  <!--<div v-if="submittedGastos && $v.gasto.numero_documento.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.numero_documento.required">Este valor es requerido.</span>
                  </div>-->
                </div>
                <div class="form-group col-md-3">
                  <label>SIAF</label>
                  <input
                      class="form-control" v-model="gasto.numero_siaf"
                      :disabled="deshabilitar_formulario"
                  />
                  <!--<div v-if="submittedGastos && $v.gasto.numero_documento.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.numero_documento.required">Este valor es requerido.</span>
                  </div>-->
                </div>
                <div class="form-group col-md-3">
                  <label>Fuente financiamiento</label>
                  <select
                      class="form-control"
                      v-model="gasto.fuente_financiamiento"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.fuente_financiamiento.$error }"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="00">00 - Recursos ordinarios</option>
                    <option value="09">09 - Recursos directamente recaudados</option>
                    <option value="19">19 - Recursos por Operaciones Oficiales De Crédito</option>
                    <option value="13">13 - Donaciones y Transferencias</option>
                    <option value="04">04 - Contribuciones a Fondo</option>
                    <option value="07">07 - Fondo de Compensación Municipal</option>
                    <option value="08">08 - Impuestos Municipales</option>
                    <option value="15">15 - Fondo de Compensación Regional</option>
                    <option value="18">18 - Canon y Sobrecanon, Regalías, Renta de Aduanas y Participaciones</option>
                  </select>
                  <div v-if="submittedGastos && $v.gasto.fuente_financiamiento.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.fuente_financiamiento.required">Este valor es requerido.</span>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Concepto</label>
                  <input
                      class="form-control" v-model="gasto.concepto"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.concepto.$error }"
                      :disabled="deshabilitar_formulario"
                  />
                  <div v-if="submittedGastos && $v.gasto.concepto.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.concepto.required">Este valor es requerido.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-3">
                  <label>Monto S/</label>
                  <input
                      class="form-control" v-model="gasto.monto"
                      :disabled="deshabilitar_formulario || deshabilitar_monto"
                  />
                  <!--<div v-if="submittedGastos && $v.gasto.monto.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.monto.required">Este valor es requerido.</span>
                  </div>-->
                </div>
                <div class="form-group col-md-3">
                  <label>Tipo costo</label>
                  <select
                      class="form-control"
                      v-model="gasto.tipo_costo"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.tipo_costo.$error }"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="CD">Costo directo</option>
                    <option value="GG">Gastos generales</option>
                    <option value="GS">Gastos supervisión</option>
                    <option value="GL">Gastos de liquidación</option>
                    <option value="GET">Gastos de expediente técnico</option>
                    <option value="GC">Gastos concurrentes</option>
                  </select>
                  <div v-if="submittedGastos && $v.gasto.tipo_costo.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.tipo_costo.required">Este valor es requerido.</span>
                  </div>

                </div>
                <div class="form-group col-md-6">
                  <label>Clasificador</label>
                  <v-select
                      :options="clasificadores"
                      label="nombre"
                      :reduce="desc=>desc.id"
                      v-model="gasto.clasificador_id"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.clasificador_id.$error }"
                      :disabled="deshabilitar_formulario"
                  />
                  <div v-if="submittedGastos && $v.gasto.clasificador_id.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.clasificador_id.required">Este valor es requerido.</span>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="form-group col-md-4">
                  <label>Tipo documento de identidad</label>
                  <select
                      class="form-control"
                      v-model="gasto.tipo_documento_identidad"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="0">Doc.trib.no.dom.sin.ruc </option>
                    <option value="1">DNI (Doc. Nacional de identidad)</option>
                    <option value="6">RUC (Registro Único de contribuyentes)</option>
                    <option value="4">Carnet de extranjería</option>
                    <option value="7">Pasaporte</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Número de documento</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control"
                           placeholder="Ingrese el ruc o dni"
                           aria-describedby="button-addon2"
                           v-model="gasto.numero_documento_identidad"
                           :disabled="deshabilitar_formulario"
                    >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary"
                              type="button"
                              id="button-addon2"
                              v-on:click="buscarDocumento"
                              :disabled="deshabilitar_formulario"
                      >
                        <i class="fa fa-search"></i>
                        Buscar
                        <b-spinner small v-show="loadingRuc"></b-spinner>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label>Denominación - Razón social </label>
                  <input
                      class="form-control" v-model="gasto.denominacion"
                      :class="{ 'is-invalid': submittedGastos && $v.gasto.denominacion.$error }"
                      :disabled="deshabilitar_formulario"
                  />
                  <div v-if="submittedGastos && $v.gasto.denominacion.$error" class="invalid-feedback">
                    <span v-if="!$v.gasto.denominacion.required">Este valor es requerido.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Observaciones</label>
                  <textarea
                      class="form-control" v-model="gasto.observaciones"
                      :disabled="deshabilitar_formulario"
                  />
                </div>
              </div>

          </b-tab>
          <b-tab title="Detalles de gasto">
            <h5> <p class="text-info">Valido solo para ordenes de compra</p> </h5>
            <div class="row">
              <div class="form-group col-md-9">
                <label>Nombre</label>
                <input
                    class="form-control" v-model="recurso_actual.nombre"
                    :disabled="deshabilitar_formulario_detalle"
                />
              </div>
              <div class="form-group col-md-3">
                <label>Tipo</label>
                <select class="form-control" v-model="recurso_actual.tipo"
                        :disabled="deshabilitar_formulario_detalle">
                  <option value="Material">Material</option>
                  <option value ="Herramienta">Herramienta</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-2">
                <label>UdM</label>
                <v-select
                    :options="unidades_medida"
                    label="nombre"
                    v-model="recurso_actual.unidad_medida"
                    :disabled="deshabilitar_formulario_detalle"
                />

              </div>
              <div class="form-group col-md-2">
                <label>Cantidad</label>
                <input
                    class="form-control" v-model="recurso_actual.cantidad"
                    :disabled="deshabilitar_formulario_detalle"
                />
              </div>
              <div class="form-group col-md-2">
                <label>Subtotal</label>
                <input
                    class="form-control" v-model="recurso_actual.subtotal"
                    :disabled="deshabilitar_formulario_detalle"
                />
              </div>
              <div class="form-group col-md-4">
                <label>Clasificador</label>
                <v-select
                    :options="clasificadores"
                    label="nombre"
                    v-model="recurso_actual.clasificador"
                    :disabled="deshabilitar_formulario_detalle"
                />
              </div>
              <div class="form-group col-md-2">
                <button class="btn btn-outline-primary mt-4"
                        v-on:click="agregarDetalle"
                        type="button"
                        :disabled="deshabilitar_formulario_detalle || (gasto.tipo_gasto!=20)"

                >
                  <i class="fa fa-plus"></i>
                  Agregar</button>
              </div>

            </div>
            <hr>
            <h4>Lista</h4>
            <div class="row">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>UdM</th>
                    <th>Cantidad</th>
                    <th>C.U.</th>
                    <th>Subtotal</th>
                    <th>Clasificador</th>
                    <th>Op</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in gasto.detalles"  v-bind:key="index">
                  <td>{{data.id}}</td>
                  <td>{{data.nombre}}</td>

                  <td>
                    <v-select
                        :options="unidades_medida"
                        label="nombre"
                        v-model="data.unidad_medida_id"
                        :reduce="dt=>dt.id"
                        :disabled="deshabilitar_formulario_detalle"
                    />

                  </td>
                  <td>{{data.cantidad}}</td>
                  <td>{{data.precio_unitario}}</td>
                  <td>{{data.subtotal}}</td>
                  <td>{{data.clasificador}}</td>
                  <td>
                    <button
                      class="btn btn-danger btn-icon btn-sm ml-1"
                      type="button"
                      v-on:click="borrarDetalle(index)" >
                    <i class="fa fa-trash"></i>
                  </button>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="text-right h4" >
                  <th colspan="7" scope="row">Total S/</th>
                  <td>{{gasto.monto}}</td>
                </tr>
                </tfoot>
              </table>

            </div>
          </b-tab>

          <b-tab title="Documentos">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label>Documento</label>
                <select class="form-control" v-model="documento_tipo_subir" >
                  <option value="10">Orden de servicio</option>
                  <option value="20">Orden de compra</option>
                  <option value="30">Comprobante de pago</option>
                  <option value="40">Pecosa</option>
                  <option value="50">Guía de remisión</option>
                  <option value="60">Conformidad</option>
                  <option value="70">Hoja de tareo</option>
                  <option value="80">Documento de habilitación</option>
                  <option value="90">Documento de rendición</option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <button type="button" class="btn btn-outline-primary mt-4" v-show="$can('gastos-modificar')" v-on:click="abrirCarga">Cargar documento</button>
              </div>
            </div>
            <div class="row font-size-12">
              <table class="table">
                <thead>
                <th>ID</th>
                <th>Tipo documento</th>
                <th>Nombre original</th>
                <th>Tamaño</th>
                <th>Op</th>
                </thead>
                <tbody>
                <tr v-for="(data,index) in gasto.archivos"  v-bind:key="index">
                  <td>
                    {{ data.id }}
                  </td>
                  <td>{{data.documento_tipo_str}}</td>

                  <td>
                    <a :href="server + '/storage/' + data.nombre"  target="_blank" >
                      {{data.nombre_original}}
                    </a>

                  </td>
                  <td>{{formatSize(data.size) }} MB</td>
                  <td>
                    <button
                        v-show="$can('gastos-modificar')"
                        class="btn btn-danger btn-icon btn-sm ml-1"
                        type="button"
                        v-on:click="borrarArchivo(data.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </b-tab>
        </b-tabs>
        <div class="row">
          <div class="col-md-12 text-right">
            <button class="btn btn-primary mr-2" type="submit"
                    :disabled="deshabilitar_formulario"
                    v-show="tab_activo==0 || tab_activo==1"
            >
              <i class="fa fa-save"></i>
              Guardar</button>
            <button class="btn btn-outline-secondary"
                    type="button"
                    v-on:click="cerrarFormulario"
            >

              <i class="fa fa-door-closed"></i>
              Salir</button>
          </div>
        </div>
        </form>
      </b-overlay>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex">
      <div>
        <button  type="button"
                 class="btn btn-primary mb-3"
                 v-on:click="nuevo"
                 v-show="$can('gastos-agregar')"
        >Nuevo</button>
      </div>
      <div class="ml-auto">

      </div>

    </div>
    <div class="row">
      <div class="form-group col-md-9">
        <label>Expediente</label>
        <v-select
            :options="expedientes"
            label="obra_expediente"
            :reduce="desc=>desc.expediente_id"
            v-model="expediente_id"
            @input="loadItems()"
        />
      </div>
      <div class="form-group col-md-3">
        <label>Total</label>
        <input class="form-control" v-model="total_monto" readonly>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label>Tipo gasto</label>
        <select class="form-control" v-model="tipo_gasto" @change="loadItems">
          <option value="0">(Todos)</option>
          <option value="10">Planilla</option>
          <option value="20">Orden de compra</option>
          <option value="30">Habilitación caja chica</option>
          <option value="40">HHabilitación encargo interno</option>
          <option value="50">Servicios</option>
          <option value="60">Cuota patronal</option>
        </select>

      </div>
      <div class="form-group col-md-3">
        <label>Fecha Documento</label>
        <input type="month"  class="form-control" v-model="mes_documento" @input="cambiarMes"/>
      </div>
      <div class="form-group col-md-3">
        <label>Fecha Devengado</label>
        <input type="month"  class="form-control" v-model="mes_devengado" @input="cambiarMes"/>
      </div>
      <div class="form-group col-md-3">
        <button class="btn btn-primary mt-4" v-on:click="borrarFiltroMes">Borrar filtros</button>
      </div>


    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Buscar</label>
        <div class="input-group">
          <input
              type="text"
              v-model="terminoBusqueda"
              class="form-control"
              placeholder="Buscar por numero de documento, concepto, monto."
              @input="buscarPorTermino"
          >
          <!--<div class="input-group-append">
            <button class="input-group-text" v-on:click="loadItems" >Buscar</button>
            <button class="input-group-text" v-on:click="loadItems" >Borrar</button>
          </div>-->
        </div>
      </div>
    </div>

    <vue-good-table
        ref="tabla"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
              enabled: true,
              }"
        :rows="rows"
        :columns="columns"
        :globalSearch="true"

        styleClass="vgt-table striped smalltable"
    >
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
              <button class="btn btn-success btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('gastos-ver')"
              ><i class="fa fa-eye"></i></button>
              <button class="btn btn-primary btn-icon btn-sm"
                      v-on:click="modificar(props.row.id)"
                      v-show="$can('gastos-modificar')"
              ><i class="fa fa-edit"></i></button>
              <button class="btn btn-danger btn-icon btn-sm ml-1"
                      v-on:click="borrar(props.row.id)"
                      v-show="$can('gastos-eliminar')"
              ><i class="fa fa-trash"></i></button>
            </span>
        <span v-else>
              {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import subirArchivos from "@/components/subir-archivos.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Gastos",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    subirArchivos,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Gastos",
      items: [
        {
          text: "Finanzas",
          href: "/",
        },
        {
          text: "Pagos",
          active: true,
        },
      ],

      isLoading: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Obra',
          field: 'obra',
        },
        {
          label: 'Gasto',
          field: 'tipo_gasto_str',
        },
        {
          label: 'Concepto',
          field: 'concepto',
        },
        {
          label: 'Fecha',
          field: 'fecha',
        },
        {
          label: 'Monto',
          field: 'monto',
        },
        {
          label: 'Devengado',
          field: 'devengado_str',
        },
        {
          label: 'F. Devengado',
          field: 'fecha_devengado',
        },
        {
          label: 'Acciones',
          field: 'acciones',
          width: '15%'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage:10
      },
      isLoadingModal:false,
      deshabilitar_formulario:false,
      deshabilitar_formulario_detalle:false,
      deshabilitar_monto:false,
      disable_monto:false,
      disable_ruc:false,
      disable_denominacion:false,
      disable_clasificador:false,
      submittedGastos:false,
      gasto:{
        id:0,
        expediente_id:null,
        meta_id:null,
        clasificador_id:null,
        detalles:[],
        monto:0
      },

      expedientes:[],
      cajas:[],
      expediente_id:null,
      caja_id:null,
      server:process.env.VUE_APP_BACKEND,
      loadingRuc:false,
      clasificadores:[],
      metas:[],
      recurso_actual:{},
      unidades_medida:[],
      //mes_actual:this.$mesActual(),
      mes_actual:null,
      fecha_mes_filtro:null,
      total_monto:0,
      documento_tipo_subir:null,
      tab_activo:0,
      clasificadores_global:[],
      terminoBusqueda:"",
      mes_documento:null,
      mes_devengado:null,
      tipo_gasto:"0",
      debounceTimer: null
   };
  },

  watch:{
    'gasto.tipo_gasto':function (val){
      if(parseInt(val)==20){
        this.deshabilitar_monto=true;
        this.deshabilitar_formulario_detalle=false;
      }
      else
      {
        this.deshabilitar_monto=false;
        this.deshabilitar_formulario_detalle=true;
      }
    }
  },

  computed:{

  },
  methods: {
    buscarPorTermino(){
      clearTimeout(this.debounceTimer);
      // Establecer un nuevo temporizador de medio segundo
      this.debounceTimer = setTimeout(() => {
         this.serverParams.page=1;
         this.$refs['tabla'].reset();
          //this.$refs['tabla'].reset();
          this.loadItems();
        // Aquí puedes realizar las acciones que necesites
      }, 500); //
    },
    borrarFiltroMes(){
      this.mes_devengado=null;
      this.mes_documento=null;
      this.tipo_gasto=0;
      this.terminoBusqueda="";

      this.serverParams.page=1;
      this.$refs['tabla'].reset();
      this.loadItems();
    },
    calcularMonto(){
      let monto_detalles_total=0;
      for(var i=0;i<this.gasto.detalles.length;i++){
        monto_detalles_total=monto_detalles_total+parseFloat(this.gasto.detalles[i].subtotal);
      }
      monto_detalles_total=parseFloat(monto_detalles_total);
      monto_detalles_total=monto_detalles_total.toFixed(2);
      this.gasto.monto=monto_detalles_total;
    },
    cambiarDevengado(){
      if(parseInt(this.gasto.devengado)==0){
        this.gasto.fecha_devengado=null;
      }
    },
    formatSize(bytes){
      return this.$formatSize(bytes);
    },
    cerrarFormulario(){
      this.$bvModal.hide("modalGastos");
    },
    ver(id){
      this.isLoading=true;
      this.deshabilitar_formulario=true;
      this.deshabilitar_formulario_detalle=true;
      this.recurso_actual={
        nombre:"",
      };
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/gastos/"+id)
          .then((response)=>{
            this.gasto=response.data;
            this.metas=response.data.metas;
            this.$bvModal.show("modalGastos");
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    agregarDetalle(){
      try{
        let recurso_id=null
        if(typeof this.recurso_actual.recurso_id!='undefined'){
          recurso_id=this.recurso_actual.recurso_id;
        }
        if(this.recurso_actual.tipo==undefined){
          this.$swal('Cuidado',"Seleccione el tipo",'warning');
          return;
        }
        this.gasto.detalles.push({
          'recurso_id':recurso_id,
          'nombre':this.recurso_actual.nombre,
          'cantidad':this.recurso_actual.cantidad,
          'tipo':this.recurso_actual.tipo,
          'unidad_medida':this.recurso_actual.unidad_medida.nombre,
          'unidad_medida_id':this.recurso_actual.unidad_medida.id,
          'subtotal':this.recurso_actual.subtotal,
          'clasificador':this.recurso_actual.clasificador.nombre,
          'clasificador_id':this.recurso_actual.clasificador.id,
        })
        this.calcularMonto();
      }
      catch (error){
        this.$swal('Cuidado',"Faltan datos",'warning');
      }

    },
    borrarDetalle(index){
      this.gasto.detalles.splice(index,1);

    },
    cargarMetasClasificadores(){
      this.$cargarMetas(
          this.gasto.expediente_id,
           (res)=>{
             this.metas=res.data;
           },
      {}
      )
      this.$cargarClasificadoresPorExpediente(  this.gasto.expediente_id,(res)=>{
        this.clasificadores=res.data
      },()=>{});
    },
    buscarDocumento(){
      if(!this.$isNumeric(this.gasto.numero_documento_identidad)){
        this.$swal('Cuidado',"Solo se acepta",'warning');
      }
      if(this.gasto.numero_documento_identidad.length ===11){
        this.loadingRuc=true;
        this.$buscarPorRUC(this.gasto.numero_documento_identidad,
            (response)=>{
              if(response.data.success){
                //console.log(response.data.denominacion_nombre_completo);
                this.gasto.denominacion=response.data.denominacion_nombre_completo;
                this.loadingRuc=false;
              }
              else
              {
                this.$swal('Cuidado',"Error no encontrado",'warning');
                this.loadingRuc=false;
              }
            }
            ,()=>{} );
      }
      else if(this.gasto.numero_documento_identidad.length ===8){
        this.loadingRuc=true;
        this.$buscarDNI(this.gasto.numero_documento_identidad,
            (response)=>{
              if(response.data.success){
                //console.log(response.data.denominacion_nombre_completo);
                this.gasto.denominacion=response.data.nombre_completo;
                this.loadingRuc=false;
              }
              else
              {
                this.$swal('Cuidado',"Error no encontrado",'warning');
                this.loadingRuc=false;
              }
            }
            ,()=>{} );
      }
      else{
        this.$swal('Cuidado',"La longitud debe ser de 8 digitos (DNI) u 11 digitos (RUC).",'warning');
      }
    },
    uploadComplete(files){
      this.isLoading=true;
      this.$bvModal.hide("modalUpload");
      //files[0]['documento_tipo']=this.documento_tipo_subir;
      //this.gasto.archivos.push(files[0]);
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/gastos/archivos",
          {
            files:files,
            documento_tipo:this.documento_tipo_subir,
            gasto_id:this.gasto.id
          })
          .then(()=>{
            //this.gasto=response.data.model;
            this.$bvModal.hide("modalUpload");
            this.actualizar();
          })
          .finally(()=>this.isLoading=false)
    },
    actualizar(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/gastos/"+this.gasto.id)
          .then((response)=>{
            this.gasto=response.data;
            //this.$bvModal.show("modalGastos");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    abrirCarga(){
      if(this.gasto.id==0){
        this.$swal('Cuidado',"Debe guardar el gasto antes de subir imagenes.",'warning');
        return;
      }
      if(this.documento_tipo_subir==null){
        this.$swal('Cuidado',"Seleccione el tipo de documento",'warning');
        return;
      }
      this.$bvModal.show("modalUpload");
    },
    submitGastos(){
      this.submittedGastos = true;
      // stop here if form is invalid
      this.$v.$touch();
      this.$v.gasto.$touch();
      if(this.$v.gasto.$error===false){
        this.guardar();
      }
      else
      {
        console.log(this.$v);
        console.log(this.gasto);
        this.$swal('Cuidado',"Formulario no valido",'warning');
        //alert("Formulario no valido")
      }
    },
    nuevo(){
      this.deshabilitar_formulario=false;
      this.deshabilitar_formulario_detalle=false;
      this.submittedGastos=false;
      this.gasto={
        id:0,
        devengado:0,
        expediente_id:null,
        meta_id:null,
        clasificador_id:null,
        tipo_documento_identidad:0,
        detalles:[],
        archivos:[]
      };
      this.$bvModal.show("modalGastos");

    },
    modificar(id){
      this.deshabilitar_formulario=false;
      this.deshabilitar_formulario_detalle=false;
      this.isLoading=true;
      this.recurso_actual={
        nombre:"",
      };
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/gastos/"+id)
          .then((response)=>{
            this.gasto=response.data;
            this.metas=response.data.metas;
            this.clasificadores=response.data.clasificadores;
            this.$bvModal.show("modalGastos");
            this.cast();
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)

    },
    cast(){
      let clasificador_encontrado=false;
      let clasificador;
      for (let j=0;j<this.clasificadores.length;j++){
        if(this.clasificadores[j].id==this.gasto.clasificador_id){
          clasificador_encontrado=true;
          break;
        }
      }
      if(clasificador_encontrado==false){
        for(let i=0;i<this.clasificadores_global.length;i++){
          if(this.clasificadores_global[i].id==this.gasto.clasificador_id){
            clasificador=this.clasificadores_global[i];
            this.clasificadores.push(clasificador);
          }
        }
      }

    },
    guardar(){
      this.isLoadingModal = true;
      const request = this.gasto.id != 0
          ? this.axios.put(`${process.env.VUE_APP_BACKEND}/api/gastos/${this.gasto.id}`, this.gasto)
          : this.axios.post(`${process.env.VUE_APP_BACKEND}/api/gastos`, this.gasto);

      request
          .then((response) => {

            //this.loadItems();
            if(this.gasto.id==0){
              this.gasto.id=response.data.gasto_id;
            }
            this.$bvModal.hide("modalGastos");
            this.loadItems();
            //this.actualizar();
            //this.gasto=response.data.model;
          })
          .catch((error) => {
            if (error.response) {
              this.$swal('Cuidado',error.response.data.mensaje,'warning');
            }
            else
            {
              this.$swal('Error',"Server error",'error');
            }
          })
          .finally(() => {
            this.isLoadingModal = false;
          });

    },
    decimal(value) {
      if (value === null) {
        return '-'
      } else {
        return parseFloat(value).toFixed(2)
      }
    },
    borrarArchivo(id){
      this.$swal.fire({
        title: '¿Esta seguro de borrar el archivo?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoadingModal=true;
          this.axios.delete(process.env.VUE_APP_BACKEND +'/api/gastos/'+this.gasto.id+'/archivos/'+id)
              .catch(()=>{
                this.$swal('error','Error eliminando','error');
              })
              .finally(
                  ()=>
                  {
                    this.isLoadingModal=false;
                    this.actualizar();
                  }

              );
        }
      })
    },
    borrar(id) {
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.axios.delete(process.env.VUE_APP_BACKEND + '/api/gastos/' + id)
              .catch((error) => {
                if (error.response) {
                  this.$swal('Cuidado!',error.response.data.mensaje,'warning');
                }
                else
                {
                  this.$swal('Error',"Server error",'error');
                }
              })
              .finally(
                  () => {
                    this.isLoading = false;
                    this.loadItems();
                  }
              );
        }
      })

    },

    say: function (message) {
      alert(message)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [{
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        }],
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    cambiarMes(){
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.mes_documento=this.mes_documento;
      this.serverParams.mes_devengado=this.mes_devengado;
      this.serverParams.expediente_id=this.expediente_id;
      this.serverParams.terminoBusqueda=this.terminoBusqueda;
      this.serverParams.tipo_gasto=this.tipo_gasto;
      this.total_monto="0.00";
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/gastos/tabla', {'params': this.serverParams})
          .then((response) => {
            //console.log(response.data.data);
            this.total_monto=response.data.monto;
            this.totalRecords = response.data.total_records;
            this.rows = response.data.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            //console.log(error);
          });
    },

  },
  mounted() {
    this.$cargarExpedientes( (res)=>{
      this.expedientes=res.data
      if(this.expedientes.length>0){
        this.expediente_id=this.expedientes[0].expediente_id;
        this.loadItems();
        //this.actualizar();
      }
    },()=>{});
    this.$cargarClasificadores((res)=>{
      this.clasificadores_global=res.data
    },()=>{});


    this.$cargarUnidadesMedida( (res)=>{
      this.unidades_medida=res.data
    },()=>{});
  },
  validations: {
    gasto:{
      expediente_id:{required},
      fecha:{required},
      tipo_gasto:{required},
      meta_id:{required},
      fuente_financiamiento:{required},
      concepto:{required},
      //monto:{required},
      tipo_costo:{required},
      clasificador_id:{required},
      denominacion:{required},

    },

  },
};
</script>

<style>
.smalltable {
  font-size: 12px !important;
}

</style>
